<mat-card>
  <mat-card-content>
    <app-form-busqueda-consulta #refFormBdqSiniestros>
    </app-form-busqueda-consulta>

    <div class="row justify-content-center">
      <div class="col-md-auto col-12">
        <div class="row justify-content-start">
          <div class="col-md-auto px-1">
            <button mat-raised-button color="primary" type="button" (click)="consultarSiniestros()">
              Buscar
            </button>
          </div>
          <div class="col-md-auto px-1">
            <button mat-raised-button color="primary" type="button" [matMenuTriggerFor]="menuBusqueda">
              <i class="fas fa-chevron-down"></i>
            </button>
            <mat-menu #menuBusqueda="matMenu" xPosition="before">
              <ng-container>
                <button mat-menu-item (click)="abrirModalAccion('individual')">
                  Individual
                </button>
              </ng-container>
            </mat-menu>
          </div>
        </div>
      </div>
    </div>

    @if (true) {
      <div class="row justify-content-center">
        <div id="tablaComplementoWeb" class="col-12">
          <app-table #myAppTable [options]="options" [fileName]="'SiniestrosWeb_Reporte'" [columnas]="columnas"
            [eventSearch]="eventData" (clickedEvent)="trigger($event)">
          </app-table>
        </div>
      </div>
    }
  </mat-card-content>
</mat-card>